const React = require("react")
const AWSData = require("./src/components/AWSData").default
// Wraps every page in a component
exports.wrapPageElement = ({ element, props }) => {
    return <AWSData {...props}> {element} </AWSData>
}